import React, { createRef, useState } from "react";
import {
    Card,
    List,
    Avatar,
    Button,
    Space,
    Tag,
    Typography,
    Badge,
    Divider,
    Empty,
    Row,
    Col,
    Statistic,
    Modal
} from "antd";
import {
    ZoomInOutlined,
    CreditCardFilled,
    CheckCircleOutlined,
    ClockCircleOutlined,
    WalletOutlined,
    BankOutlined,
    MobileOutlined,
    DollarOutlined,
    FileTextOutlined,
    CalendarOutlined
} from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import { frenchDate } from "../../../../variables/functions";
import { displayNumbers } from "../../../../variables/numbersFunctions";
import RecuCurrentFormat from "../../components/docs/RecuCurrentFormat";

const { Title, Text } = Typography;

const MouvementsContent = ({
    reglements,
    contrat,
    loadPaymentModal,
    rightsService
}) => {

    const printRecu = createRef();
    const [openRecu, setOpenRecu] = useState(false);
    const [selectedReglement, setSelectedReglement] = useState(null);

    const handleRecu = useReactToPrint({
        content: () => printRecu.current,
    });

    const loadModal = (item) => {
        setSelectedReglement(item);
        console.log("item recu ", item);
        console.log("contrat recu ", contrat);
        setTimeout(() => {
            setOpenRecu(true);
        }, 500);
    }

    const primaryColor = "#1890ff";
    const secondaryColor = "#242166";
    const successColor = "#52c41a";
    const warningColor = "#faad14";
    // const dangerColor = "#ff4d4f";

    const cardStyle = {
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: `1px solid ${secondaryColor}15`,
        marginBottom: "16px"
    };

    const getPaymentIcon = (modePaiement) => {
        switch (modePaiement) {
            case "ESPECES":
                return <WalletOutlined style={{ fontSize: "20px", color: successColor }} />;
            case "ESPECE":
                return <WalletOutlined style={{ fontSize: "20px", color: successColor }} />;
            case "BANQUE":
                return <BankOutlined style={{ fontSize: "20px", color: primaryColor }} />;
            case "MOBILE_MONEY":
                return <MobileOutlined style={{ fontSize: "20px", color: warningColor }} />;
            case "RISTOURNE":
                return <DollarOutlined style={{ fontSize: "20px", color: secondaryColor }} />;
            default:
                return <FileTextOutlined style={{ fontSize: "20px", color: "#999" }} />;
        }
    };

    const getPaymentMethodLabel = (modePaiement) => {
        const labels = {
            "ESPECES": "Espèces",
            "ESPECE": "Espèces",
            "BANQUE": "Chèque Bancaire",
            "MOBILE_MONEY": "Mobile Money",
            "RISTOURNE": "Ristourne"
        };
        return labels[modePaiement] || "Non défini";
    };

    const getStatusTag = (item) => {
        if (item.modePaiement || item.montantPaye || item?.avenant?.code === "AN") {
            return (
                <Tag
                    icon={<CheckCircleOutlined />}
                    color="success"
                    style={{
                        borderRadius: "6px",
                        padding: "4px 12px",
                        fontSize: "13px",
                        fontWeight: 500
                    }}
                >
                    Payé
                </Tag>
            );
        }
        return (
            <Tag
                icon={<ClockCircleOutlined />}
                color="warning"
                style={{
                    borderRadius: "6px",
                    padding: "4px 12px",
                    fontSize: "13px",
                    fontWeight: 500
                }}
            >
                En attente
            </Tag>
        );
    };

    const getVersementTag = (versementCompagnie) => {
        if (versementCompagnie) {
            return (
                <Tag
                    color="success"
                    style={{
                        borderRadius: "6px",
                        padding: "4px 12px",
                        fontSize: "12px"
                    }}
                >
                    Prime Versée
                </Tag>
            );
        }
        return (
            <Tag
                color="error"
                style={{
                    borderRadius: "6px",
                    padding: "4px 12px",
                    fontSize: "12px"
                }}
            >
                Prime Non Versée
            </Tag>
        );
    };

    // Calculer les statistiques
    const totalPaye = reglements?.filter(r => r.modePaiement || r.montantPaye).reduce((acc, r) => acc + (r.montant || 0), 0) || 0;
    const totalEnAttente = reglements?.filter(r => !r.modePaiement && !r.montantPaye && r?.avenant?.code !== "AN").reduce((acc, r) => acc + (r.montant || 0), 0) || 0;
    const nombreMouvements = reglements?.length || 0;

    return (
        <div style={{
            background: "white",
            padding: "32px",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
        }}>
            {/* En-tête avec statistiques */}
            <div style={{
                marginBottom: "32px",
                paddingBottom: "24px",
                borderBottom: `2px solid ${secondaryColor}20`
            }}>
                <Title level={3} style={{ margin: 0, color: secondaryColor, marginBottom: "24px" }}>
                    <FileTextOutlined style={{ marginRight: "12px" }} />
                    Historique des Mouvements
                </Title>

                <Row gutter={[24, 24]}>
                    <Col xs={24} sm={8}>
                        <Card style={{ ...cardStyle, border: `2px solid ${successColor}30` }}>
                            <Statistic
                                title={<Text style={{ color: "#666", fontSize: "14px" }}>Total Payé</Text>}
                                value={displayNumbers(totalPaye)}
                                suffix="FCFA"
                                valueStyle={{ color: successColor, fontSize: "24px", fontWeight: 600 }}
                                prefix={<CheckCircleOutlined />}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={8}>
                        <Card style={{ ...cardStyle, border: `2px solid ${warningColor}30` }}>
                            <Statistic
                                title={<Text style={{ color: "#666", fontSize: "14px" }}>En Attente</Text>}
                                value={displayNumbers(totalEnAttente)}
                                suffix="FCFA"
                                valueStyle={{ color: warningColor, fontSize: "24px", fontWeight: 600 }}
                                prefix={<ClockCircleOutlined />}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={8}>
                        <Card style={{ ...cardStyle, border: `2px solid ${primaryColor}30` }}>
                            <Statistic
                                title={<Text style={{ color: "#666", fontSize: "14px" }}>Nombre de Mouvements</Text>}
                                value={nombreMouvements}
                                valueStyle={{ color: primaryColor, fontSize: "24px", fontWeight: 600 }}
                                prefix={<FileTextOutlined />}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>

            {/* Liste des mouvements */}
            {reglements && reglements.length > 0 ? (
                <List
                    itemLayout="horizontal"
                    dataSource={reglements}
                    renderItem={(item, index) => {
                        const isPaid = item.modePaiement || item.montantPaye || item?.avenant?.code === "AN";

                        return (
                            <Card
                                style={{
                                    ...cardStyle,
                                    background: isPaid ? "#f6ffed" : "#fffbe6",
                                    borderLeft: `4px solid ${isPaid ? successColor : warningColor}`,
                                    transition: "all 0.3s ease",
                                    cursor: "pointer"
                                }}
                                hoverable
                                bodyStyle={{ padding: "20px 24px" }}
                            >
                                <List.Item
                                    style={{ border: "none", padding: 0 }}
                                    actions={[
                                        isPaid ? (
                                            <Button
                                                type="primary"
                                                icon={<ZoomInOutlined />}
                                                onClick={() => loadModal(item)}
                                                style={{
                                                    borderRadius: "8px",
                                                    height: "40px",
                                                    background: primaryColor,
                                                    borderColor: primaryColor,
                                                    fontWeight: 500,
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                                }}
                                            >
                                                Prévisualiser
                                            </Button>
                                        ) : (
                                            <Button
                                                type="primary"
                                                danger
                                                icon={<CreditCardFilled />}
                                                disabled={!rightsService("HLA037")}
                                                onClick={() => loadPaymentModal(item)}
                                                style={{
                                                    borderRadius: "8px",
                                                    height: "40px",
                                                    fontWeight: 500,
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                                }}
                                            >
                                                Régler
                                            </Button>
                                        )
                                    ]}
                                >
                                    <List.Item.Meta
                                        avatar={
                                            <Badge
                                                count={index + 1}
                                                style={{
                                                    background: secondaryColor,
                                                    fontSize: "14px",
                                                    fontWeight: 600
                                                }}
                                            >
                                                <Avatar
                                                    size={64}
                                                    style={{
                                                        background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)`,
                                                        fontSize: "20px",
                                                        fontWeight: 600
                                                    }}
                                                >
                                                    {item?.avenant?.code || contrat?.avenant?.code || "N/A"}
                                                </Avatar>
                                            </Badge>
                                        }
                                        title={
                                            <Space direction="vertical" size="small" style={{ width: "100%" }}>
                                                <Space size="middle">
                                                    <Text strong style={{ fontSize: "16px", color: secondaryColor }}>
                                                        {item?.avenant?.nom || contrat?.avenant?.nom}
                                                    </Text>
                                                    {getStatusTag(item)}
                                                </Space>
                                            </Space>
                                        }
                                        description={
                                            <Space direction="vertical" size="middle" style={{ width: "100%", marginTop: "12px" }}>
                                                {/* Montant */}
                                                <div style={{
                                                    background: "white",
                                                    padding: "12px 16px",
                                                    borderRadius: "8px",
                                                    border: `1px solid ${secondaryColor}10`
                                                }}>
                                                    <Space size="large" wrap>
                                                        <div>
                                                            <Text type="secondary" style={{ fontSize: "12px", display: "block" }}>
                                                                {isPaid ? "Montant payé" : "Montant à payer"}
                                                            </Text>
                                                            <Text strong style={{ fontSize: "20px", color: isPaid ? successColor : warningColor }}>
                                                                {displayNumbers(item?.montant)} FCFA
                                                            </Text>
                                                        </div>

                                                        {/* Mode de paiement */}
                                                        {item.modePaiement && (
                                                            <Divider type="vertical" style={{ height: "40px" }} />
                                                        )}
                                                        {item.modePaiement && (
                                                            <div>
                                                                <Text type="secondary" style={{ fontSize: "12px", display: "block" }}>
                                                                    Mode de paiement
                                                                </Text>
                                                                <Space>
                                                                    {getPaymentIcon(item.modePaiement)}
                                                                    <Text strong style={{ fontSize: "14px" }}>
                                                                        {getPaymentMethodLabel(item.modePaiement)}
                                                                    </Text>
                                                                </Space>
                                                            </div>
                                                        )}

                                                        {/* Date de paiement */}
                                                        {item.dateReglement && (
                                                            <>
                                                                <Divider type="vertical" style={{ height: "40px" }} />
                                                                <div>
                                                                    <Text type="secondary" style={{ fontSize: "12px", display: "block" }}>
                                                                        <CalendarOutlined style={{ marginRight: "4px" }} />
                                                                        Date de paiement
                                                                    </Text>
                                                                    <Text strong style={{ fontSize: "14px", color: primaryColor }}>
                                                                        {frenchDate(item.dateReglement)}
                                                                    </Text>
                                                                </div>
                                                            </>
                                                        )}
                                                    </Space>
                                                </div>

                                                {/* Tag versement pour courtier */}
                                                {contrat?.courtier && (
                                                    <div>
                                                        {getVersementTag(item?.versementCompagnie)}
                                                    </div>
                                                )}
                                            </Space>
                                        }
                                    />
                                </List.Item>
                            </Card>
                        );
                    }}
                />
            ) : (
                <Card style={cardStyle}>
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            <Space direction="vertical" size="small">
                                <Text style={{ fontSize: "16px", color: "#999" }}>
                                    Aucun mouvement effectué sur ce contrat
                                </Text>
                                <Text type="secondary" style={{ fontSize: "14px" }}>
                                    Les paiements et avenants apparaîtront ici
                                </Text>
                            </Space>
                        }
                        style={{ padding: "60px 20px" }}
                    />
                </Card>
            )}
            <Modal
                title="Reçu de Paiement"
                open={openRecu}
                onCancel={() => setOpenRecu(false)}
                footer={null}
                width={1200}
                height={2000}
            >
                {selectedReglement ? (
                    <RecuCurrentFormat ref={printRecu} contrat={contrat} reglement={selectedReglement} />
                ) : (
                    <Text>Aucun reçu disponible.</Text>
                )}
                <Button
                    type="primary"
                    style={{ marginTop: "20px", borderRadius: "8px", height: "40px", fontWeight: 500 }}
                    onClick={() => {
                        handleRecu();
                    }}
                >
                    Imprimer le Reçu
                </Button>
            </Modal>
        </div>
    );
};

export default MouvementsContent;